import { StyleSheet } from 'react-native';
import { theme } from '../../../../theme';

export const updateGateStyles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: theme.background.primary,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: theme.spacing.huge,
    zIndex: 9999,
    elevation: 9999,
  },
  content: {
    alignItems: 'center',
    maxWidth: 420,
    width: '100%',
  },
  iconWrap: {
    width: 88,
    height: 88,
    borderRadius: theme.borderRadius.full,
    backgroundColor: theme.background.cardElevated,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing.xxl,
  },
  title: {
    ...theme.typography.h1,
    color: theme.black,
    textAlign: 'center',
    marginBottom: theme.spacing.md,
  },
  message: {
    ...theme.typography.body,
    color: theme.gray[500],
    textAlign: 'center',
    marginBottom: theme.spacing.huge,
  },
  button: {
    backgroundColor: theme.primary,
    borderRadius: theme.borderRadius.md,
    paddingVertical: theme.spacing.lg,
    paddingHorizontal: theme.spacing.huge,
    minHeight: theme.touchTargets.minHeight,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  buttonPressed: {
    opacity: 0.85,
  },
  buttonHovered: {
    backgroundColor: theme.primaryDark,
  },
  buttonText: {
    ...theme.typography.label,
    color: theme.onPrimary,
    fontWeight: '600',
  },
});
